import { AddMemberToTeamRequest, RemoveMemberFromTeamRequest } from './team-member.types';

import {
  API_HOST,
  HttpDeleteOptions,
  HttpPostOptions,
  getHttpDeleteOptions,
  getHttpPostOptions
} from '../../utils/api.util';

const getEndpoint = (externalReference: string) => `${API_HOST}/teams/${externalReference}`;
const getSpecificEndpoint = (teamExternalReference: string, memberExternalReference: string) =>
  `${getEndpoint(teamExternalReference)}/members/${memberExternalReference}`;

export const getAddMemberToTeamRequest = (data: AddMemberToTeamRequest): [string, HttpPostOptions<undefined>] => [
  getSpecificEndpoint(data.teamExternalReference, data.memberExternalReference),
  getHttpPostOptions(undefined)
];

export const getRemoveMemberFromTeamRequest = (data: RemoveMemberFromTeamRequest): [string, HttpDeleteOptions] => [
  getSpecificEndpoint(data.teamExternalReference, data.memberExternalReference),
  getHttpDeleteOptions()
];
